var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusList = function SvgStatusList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 4,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM5.905 5.5c.233.401.553.744.938 1H2.5a.5.5 0 0 1 0-1zM5.674 3c-.11.313-.174.649-.174 1h-3a.5.5 0 0 1 0-1zM8.5 3a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1"
  })));
};
export default SvgStatusList;